module.exports = vendor_react_lib;